// src/pages/About.js
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { localePath } from "../utils/content";
import Seo from "../components/Seo";

export default function About() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <>
      <Seo
        path="about"
        title={t("menu.about")}
        description={t("mission.intro")}
        breadcrumb={[
          { name: t("common.home"), path: "" },
          { name: t("menu.about"), path: "about" },
        ]}
      />

      <section className="page-header">
        <div className="container">
          <div className="page-header__inner">
            <div className="page-header__crumbs">
              <Link to={localePath(lang)}>{t("common.home")}</Link>
              <span>/</span>
              <span>{t("menu.about")}</span>
            </div>
            <h1>{t("brand.full")}</h1>
            <p>{t("hero.subtitle")}</p>
          </div>
        </div>
      </section>

      <section style={{ background: "var(--ivory)" }}>
        <div className="container">
          <div className="detail-layout">
            <div className="detail-content">
              <div className="eyebrow">{t("mission.eyebrow")}</div>
              <h2 style={{ fontSize: 38 }}>{t("mission.title")}</h2>

              <p style={{ fontSize: 19, color: "var(--muted)", lineHeight: 1.75 }}>
                {t("mission.intro")}
              </p>

              <h3>{t("about.responsibilities_title")}</h3>
              <ul>
                <li>{t("about.responsibility_1")}</li>
                <li>{t("about.responsibility_2")}</li>
                <li>{t("about.responsibility_3")}</li>
              </ul>

              <blockquote>
                {t("about.ccma_management")}
              </blockquote>

              <h3>{t("about.ccma_missions_title")}</h3>
              <ul>
                <li>{t("ccma.m1")}</li>
                <li>{t("ccma.m2")}</li>
                <li>{t("ccma.m3")}</li>
              </ul>

              <div style={{ marginTop: 48, display: "flex", gap: 14, flexWrap: "wrap" }}>
                <Link to={localePath(lang, "page/12")} className="btn btn-primary">
                  {t("hero.cta_secondary")}
                </Link>
                <Link to={localePath(lang, "contact")} className="btn btn-ghost">
                  {t("contact.title")}
                </Link>
              </div>
            </div>

            <aside className="detail-aside">
              <div className="aside-card">
                <h4>{t("contact.title")}</h4>
                <div style={{ marginBottom: 14, fontSize: 14, color: "var(--muted)" }}>
                  <i className="bi bi-envelope" style={{ marginRight: 8, color: "var(--gold-deep)" }} />
                  <a href={`mailto:${t("contact.email_site")}`} style={{ color: "var(--ink)" }}>{t("contact.email_site")}</a>
                </div>
                <div style={{ marginBottom: 14, fontSize: 14, color: "var(--muted)" }}>
                  <i className="bi bi-telephone" style={{ marginRight: 8, color: "var(--gold-deep)" }} />
                  <bdi>{t("contact.phone")}</bdi>
                </div>
                <div style={{ fontSize: 14, color: "var(--muted)" }}>
                  <i className="bi bi-geo-alt" style={{ marginRight: 8, color: "var(--gold-deep)" }} />
                  {t("contact.address")}
                </div>
              </div>

              <div className="aside-card">
                <h4>{t("footer.ccma_title")}</h4>
                <ul>
                  <li><Link to={localePath(lang, "page/12")}>{t("ccma.pages.presentation")}</Link></li>
                  <li><Link to={localePath(lang, "page/15")}>{t("ccma.pages.legal_framework")}</Link></li>
                  <li><Link to={localePath(lang, "page/17")}>{t("ccma.pages.referral")}</Link></li>
                  <li><Link to={localePath(lang, "page/18")}>{t("ccma.pages.arbitration_rules")}</Link></li>
                  <li><Link to={localePath(lang, "page/2")}>{t("ccma.pages.arbitration_request")}</Link></li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </>
  );
}